"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UITooltip = _interopRequireDefault(require("../../tooltip/UITooltip"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonChildWrapper = _styledComponents.default.span.withConfig({
  displayName: "DropdownMenuOption__ButtonChildWrapper",
  componentId: "akncxe-0"
})(_templateObject());

var DropdownMenuOption = _react.default.createClass({
  displayName: "DropdownMenuOption",
  propTypes: {
    children: _react.PropTypes.node,
    selected: _react.PropTypes.bool,
    tooltip: _react.PropTypes.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      selected: null
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        selected = _this$props.selected,
        tooltip = _this$props.tooltip,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "selected", "tooltip"]);
    var selectedProps = selected !== null ? {
      role: 'menuitemcheckbox',
      'aria-checked': selected
    } : {
      role: 'menuitem'
    };
    return _react.default.createElement(_UITooltip.default, {
      title: tooltip,
      placement: "right"
    }, _react.default.createElement(_UIButton.default, (0, _extends2.default)({
      use: "transparent"
    }, rest, selectedProps), _react.default.createElement(ButtonChildWrapper, null, _react.default.createElement("span", {
      className: "private-dropdown__button-label uiDropdown__buttonLabel"
    }, children), selected ? _react.default.createElement(_UIIcon.default, {
      name: "check",
      size: parseInt(_sizes.DROPDOWN_FONT_SIZE, 10),
      color: _colors.EERIE
    }) : null)));
  }
});

var _default = DropdownMenuOption;
exports.default = _default;
module.exports = exports.default;